import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '@/components/shared/Sidebar';
import { Home, User, Shield, Settings, ClipboardList, Sparkles, MapPin, MessageSquare, BarChart3, Brain, Gift, Wallet } from 'lucide-react';
import ApplicantHome from './ApplicantHome';
import ApplicantProfile from './ApplicantProfile';
import ApplicantScreenings from './ApplicantScreenings';
import ApplicantRequests from './ApplicantRequests';
import ApplicantSettings from './ApplicantSettings';
import ApplicantJobMatches from './ApplicantJobMatches';
import ApplicantJourney from './ApplicantJourney';
import ApplicantReviews from './ApplicantReviews';
import SkillExplorer from './SkillExplorer';
import ApplicantPrepSimulator from './ApplicantPrepSimulator';
import ApplicantReferral from './ApplicantReferral';
import ApplicantWallet from './ApplicantWallet';
import CandidateJourneyDetail from '@/components/shared/CandidateJourneyDetail';
import ContactUs from '@/pages/ContactUs';
import PrepPromoBanner from '@/components/shared/PrepPromoBanner';
import WhatsAppFloatButton from '@/components/shared/WhatsAppFloatButton';

const navItems = [
  { to: '/applicant', icon: Home, label: 'Dashboard' },
  { to: '/applicant/profile', icon: User, label: 'Profile' },
  { to: '/applicant/job-matches', icon: Sparkles, label: 'Job Matches' },
  { to: '/applicant/journey', icon: MapPin, label: 'My Journey' },
  { to: '/applicant/skills', icon: BarChart3, label: 'Skill Explorer' },
  { to: '/applicant/prep', icon: Brain, label: 'Interview Prep' },
  { to: '/applicant/reviews', icon: MessageSquare, label: 'Reviews' },
  { to: '/applicant/wallet', icon: Wallet, label: 'Wallet' },
  { to: '/applicant/refer', icon: Gift, label: 'Refer & Earn' },
  { to: '/applicant/settings', icon: Settings, label: 'Settings' },
];

export default function ApplicantDashboard() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0a0a0b]" data-testid="applicant-dashboard">
      <PrepPromoBanner />
      <WhatsAppFloatButton />
      <Sidebar items={navItems} title="Applicant" />
      <main className="flex-1 overflow-auto pt-14 lg:pt-0">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <Routes>
            <Route index element={<ApplicantHome />} />
            <Route path="profile" element={<ApplicantProfile />} />
            <Route path="job-matches" element={<ApplicantJobMatches />} />
            <Route path="journey" element={<ApplicantJourney />} />
            <Route path="journey/:matchId" element={<CandidateJourneyDetail role="applicant" />} />
            <Route path="skills" element={<SkillExplorer />} />
            <Route path="screenings" element={<ApplicantScreenings />} />
            <Route path="prep" element={<ApplicantPrepSimulator />} />
            <Route path="reviews" element={<ApplicantReviews />} />
            <Route path="wallet" element={<ApplicantWallet />} />
            <Route path="refer" element={<ApplicantReferral />} />
            <Route path="requests" element={<ApplicantRequests />} />
            <Route path="settings" element={<ApplicantSettings />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="contact/ticket/:ticketId" element={<ContactUs />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
